import styled from "styled-components";

interface IProps {
    title?: string;
    result?: number;
    perday?: string;
    isBorder?: boolean;
    colorText?: string;
    bgColor?: string;
}

export const BoxBmiResult = (props: IProps) => {
    return (
        <StyledBoxBmiResult
            isBorder={props.isBorder}
            colorText={props.colorText}
            bgColor={props.bgColor}
        >
            <div className="title-box-bmi-result">{props.title || "title"}</div>
            <div className="result-box-bmi-result">{props.result || "result"}</div>
            <div className="day-box-bmi-result">{props.perday || "Per Day"}</div>
        </StyledBoxBmiResult>
    );
};

const StyledBoxBmiResult = styled.div<{ isBorder?: boolean; colorText?: string; bgColor?: string }>`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 20px 0;
    background-color: ${(props) => props.bgColor || "#fff"};
    border-radius: 14px;
    border: ${(props) => (props.isBorder ? "3px solid #000" : "none")};
    gap: 2px;

    .title-box-bmi-result {
        font-size: 11px;
        line-height: 14px;
        color: ${(props) => props.colorText || "#000"};
    }
    .result-box-bmi-result {
        font-size: 24px;
        line-height: 27px;
        font-weight: 600px;
        color: ${(props) => props.colorText || "#000"};
    }
    .day-box-bmi-result {
        font-size: 11px;
        line-height: 14px;
        color: ${(props) => props.colorText || "#000"};
    }
`;
